import { useCallback } from 'react'

import { WindowWithDataLayer } from '@/features/analytics/types'

import { normalizeDestinationUrl } from './normalize-destination-url'

declare const window: WindowWithDataLayer

export type DataLayerProps = {
    event: string
    elementType: string
    elementIndex: number | string
    itemID: string
    elementName?: string
    destinationUrl: string
    componentId?: string | null
    ImageUrl?: string | null
    elementGroupName?: string
}

export const useDataLayerPush = () => {
    const pushToDataLayer = useCallback((data: DataLayerProps) => {
        if (typeof window === 'undefined' || !window?.dataLayer) {
            return
        }

        // Normalize destination URL
        const destinationUrl = normalizeDestinationUrl(data.destinationUrl)

        window.dataLayer.push({
            ...data,
            destinationUrl,
            page_path: window.location.href,
        })
    }, [])

    return pushToDataLayer
}
